module.exports = __webpack_public_path__ + "static/media/lorelai-6.3272817e.wav";